"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("./StringUtils");
var StringBuilder = /** @class */ (function () {
    /**
     *
     */
    function StringBuilder(text) {
        if (text === void 0) { text = ""; }
        this.m_data = Array.from(text);
    }
    StringBuilder.prototype.append = function (value) {
        var text = StringUtils_1.default.SafeToString(value);
        this.m_data.push(text);
        return this;
    };
    StringBuilder.prototype.toString = function () {
        return this.m_data.join("");
    };
    StringBuilder.prototype.insert = function (index, item) {
        this.m_data.add(index, item);
    };
    StringBuilder.prototype.length = function () {
        return this.toString().length;
    };
    StringBuilder.prototype.isEmpty = function () {
        return this.m_data.length === 0;
    };
    StringBuilder.prototype.charAt = function (position) {
        return this.toString().charAt(position);
    };
    return StringBuilder;
}());
exports.default = StringBuilder;

//# sourceMappingURL=StringBuilder.js.map
